import { Box, Typography } from '@mui/material';
import React from 'react';

interface KeyValueProps {
  label: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Label + value block for detail screens. Keeps label casing (no forced uppercase).
 */
export function KeyValue({ label, children }: KeyValueProps) {
  return (
    <Box mb={2}>
      <Typography
        variant="body2"
        color="grey.600"
        sx={{
          display: 'block',
          mb: 0.5,
          fontWeight: 400,
        }}
      >
        {label}
      </Typography>
      <Typography variant="body1" component="div" color="text.primary">
        {children}
      </Typography>
    </Box>
  );
}
